import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { getCompanyByCompanyIdApi } from '@src/api/companies';
import { getProjectsListApi } from '@src/api/projects';
import { GetProjectsParams } from '@src/api/projects/projects';

const getCompaniesDetail = createAsyncThunk(
  'companies/getCompaniesDetail',
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await getCompanyByCompanyIdApi(id);

      return response.result.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return rejectWithValue(error.response?.data);
      }
      throw error;
    }
  }
);
const getProjectsDetail = createAsyncThunk(
  'companies/getProjectsDetail',
  async (
    {
      page = 1,
      limit = 20,
      sortBy = [''],
      searchBy = '',
      search,
      filter,
    }: GetProjectsParams,
    { rejectWithValue }
  ) => {
    try {
      const response = await getProjectsListApi({
        page,
        limit,
        sortBy,
        searchBy,
        search,
        filter,
      });

      return response.result.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return rejectWithValue(error.response?.data);
      }
      throw error;
    }
  }
);

export { getCompaniesDetail, getProjectsDetail };
